import React, { useState } from 'react';
import { Route, Switch } from 'react-router';
import SourceContext from 'helpers/SourceContext';

import NameYourData from 'pages/Directory/NameYourData';
import ChooseSourceType from 'pages/Directory/ChooseSourceType';
import Authorization from 'pages/Directory/Authorization';
import SelectGroups from 'pages/Directory/SelectGroups';
import UploadCsv from 'pages/Directory/UploadCsv';
import MapAttributes from 'pages/Directory/MapAttributes';
import SyncSettings from 'pages/Directory/SyncSettings';
import WorkdayOAuthForm from 'pages/Directory/WorkdayOAuthForm';
import WorkdayDataFilterForm from '../WorkdayDataFilterForm';

import {
  NAME_YOUR_DATA_URL,
  CHOOSE_SOURCE_TYPE_URL,
  AUTHORIZE_DATA_ACCESS_URL,
  CHOOSE_SYNC_GROUPS_URL,
  UPLOAD_CSV_URL,
  MAP_ATTRIBUTES_URL,
  DATA_SETTINGS_URL,
  SOURCE_WIZARD_BASE_URL,
  SOURCE_WIZARD_BASE_URL_W_DIRECTORY_ID,
  SOURCE_WIZARD_BASE_URL_W_DIRECTORY_SOURCE_IDS,
  WORKDAY_OAUTH_FORM_URL,
  WORKDAY_DATA_FILTER_FORM_URL,
} from 'pages/Directory/consts';

interface Props {
  sourceState: any;
}

function Wizard({ sourceState }: Props) {
  const [sourceInfo, setSourceInfo] = useState(sourceState);

  return (
    <SourceContext.Provider value={{ sourceInfo, setSourceInfo }}>
      <Switch>
        <Route
          path={[
            `${SOURCE_WIZARD_BASE_URL}${CHOOSE_SOURCE_TYPE_URL}`,
            `${SOURCE_WIZARD_BASE_URL_W_DIRECTORY_ID}${CHOOSE_SOURCE_TYPE_URL}`,
          ]}
          component={ChooseSourceType}
        />
        <Route
          path={[
            `${SOURCE_WIZARD_BASE_URL}${NAME_YOUR_DATA_URL}`,
            `${SOURCE_WIZARD_BASE_URL_W_DIRECTORY_ID}${NAME_YOUR_DATA_URL}`,
          ]}
          component={NameYourData}
        />
        <Route
          path={`${SOURCE_WIZARD_BASE_URL_W_DIRECTORY_SOURCE_IDS}${WORKDAY_OAUTH_FORM_URL}`}
          component={WorkdayOAuthForm}
        />
        <Route
          path={`${SOURCE_WIZARD_BASE_URL_W_DIRECTORY_SOURCE_IDS}${AUTHORIZE_DATA_ACCESS_URL}`}
          component={Authorization}
        />
        <Route
          path={`${SOURCE_WIZARD_BASE_URL_W_DIRECTORY_SOURCE_IDS}${CHOOSE_SYNC_GROUPS_URL}`}
          component={SelectGroups}
        />
        <Route
          path={`${SOURCE_WIZARD_BASE_URL_W_DIRECTORY_SOURCE_IDS}${WORKDAY_DATA_FILTER_FORM_URL}`}
          component={WorkdayDataFilterForm}
        />
        <Route
          path={`${SOURCE_WIZARD_BASE_URL_W_DIRECTORY_SOURCE_IDS}${UPLOAD_CSV_URL}`}
          component={UploadCsv}
        />
        <Route
          path={`${SOURCE_WIZARD_BASE_URL_W_DIRECTORY_SOURCE_IDS}${MAP_ATTRIBUTES_URL}`}
          component={MapAttributes}
        />
        <Route
          path={`${SOURCE_WIZARD_BASE_URL_W_DIRECTORY_SOURCE_IDS}${DATA_SETTINGS_URL}`}
          component={SyncSettings}
        />
      </Switch>
    </SourceContext.Provider>
  );
}

export default Wizard;
